import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpParams} from '@angular/common/http';
import {RestClientService} from './rest-client/rest-client.service';
import {Location} from './model';
import {Page, PageRequest} from './model/page';

@Injectable({
  providedIn: 'root'
})
export class LocationService {

  constructor(protected restClient: RestClientService) {
  }

  public findByNameMatchingText(merchantId: string, text: string): Observable<Location[]> {
    const params = new HttpParams().append('text', text);
    return this.restClient.getWithParams<Location[]>(`/merchants/${merchantId}/locations`, params);
  }

  public findAllForMerchant(merchantId: string, stateId?: string | null, cityId?: string | null): Observable<Location[]> {
    let params = new HttpParams();

    if (stateId) {
      params = params.append('stateId', stateId);
    }

    if (cityId) {
      params = params.append('cityId', cityId);
    }

    return this.restClient.getWithParams<Location[]>(`/merchants/${merchantId}/locations/all`, params);
  }

  public findMerchantLocationsPage(
    merchantId: string,
    pageRequest: PageRequest<Location>,
    searchText?: string,
    stateId?: string,
    cityId?: string
  ): Observable<Page<Location>> {
    let params = new HttpParams()
      .set('page', pageRequest.page.toString())
      .set('size', pageRequest.size.toString());

    if (searchText && searchText.trim()) {
      params = params.append('addressSearchText', searchText.trim());
    }

    if (stateId) {
      params = params.append('stateId', stateId);
    }

    if (cityId) {
      params = params.append('cityId', cityId);
    }

    if (pageRequest.sort?.property && pageRequest.sort?.direction) {
      params = params.append('sort', `${pageRequest.sort.property},${pageRequest.sort.direction}`);
    }

    return this.restClient.getWithParams<Page<Location>>(`/merchants/${merchantId}/locations`, params);
  }
}
